import ping from '../elements/ping.js';
ping.register();
